import React from 'react';
import PropTypes from 'prop-types';

const RowNumbers = ({ row, rowNumber, middleRow }) =>
  row.map((seat, index) => (
    <div
      className='seat'
      key={`row-${seat ? seat.seatNum : ''}-${index}`}
      id={`${seat.row}#initial#${seat.seatNum}`}
    >
      <span style={{ minWidth: 33 }} className='row-number'>
        {seat.seatNum}
      </span>

      {middleRow === index ? (
        <span className='row-number'>
          {rowNumber < 10 ? <span>&nbsp;&nbsp;</span> : <span>&nbsp;</span>}
        </span>
      ) : null}
    </div>
  ));

RowNumbers.propTypes = {
  row: PropTypes.arrayOf(PropTypes.object),
  rowNumber: PropTypes.number,
  middleRow: PropTypes.number,
};

export default RowNumbers;



// WEBPACK FOOTER //
// ./src/components/seats/seatSelection/RowNumbers.js